























import { Component, Vue, Watch } from 'vue-property-decorator'
import { foodStore, VendorFoodUpdate } from '../store/food-store'
import { VendorFood } from 'foodme-firestore-db'

@Component
export default class FoodListPage extends Vue {
  foodTitle = ''
  foodDescription = ''
  foodPrice = '0.00'

  get food () {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return foodStore.foodList.find(f => f.id === this.$f7route!.params.foodId) || { id: '' }
  }

  @Watch('food', { immediate: true, deep: true })
  onFoodChanged (value: VendorFood) {
    // console.log('food-edit onFoodChanged', value, oldValue)
    this.foodTitle = value.title || ''
    this.foodDescription = value.description || ''
    this.foodPrice = value.price || '0.00'
  }

  async saveFood () {
    // console.log('food-edit saveFood')
    const updatedFood: VendorFoodUpdate = {
      id: this.food?.id ?? '',
      title: this.foodTitle,
      description: this.foodDescription,
      price: this.foodPrice
    }

    await foodStore.saveFood(updatedFood)

    // eslint-disable-next-line no-unused-expressions
    this.$f7router?.back('/food-list')
  }
}
